/* ==================================================
 *  Header
 * ==================================================*/

(function () {

  'use strict';

  var $header = $('.header');
  var $button = $('[data-header]');
  var $headerBg = $('.header__bg');
  var $searchForm = $('#siteGlobalSearch');
  var $searchClose = $('[data-search-close]');
  var buttonClass = 'in';
  var targetClass = 'header--in';

  $(document).on('click', '[data-header]', function (ev) {
    ev.preventDefault();
    ev.stopPropagation();

    var $this = $(this);
    var target = $this.attr('data-header');

    if (window.matchMedia('(min-width: 768px)').matches) {
      $('.' + targetClass).removeClass(targetClass);
    }

    if ($this.hasClass(buttonClass)) {
      $button.removeClass(buttonClass);
      $(target).removeClass(targetClass);
    } else {
      $(target).addClass(targetClass);
      $this.addClass(buttonClass);
      $headerBg.addClass(targetClass);
    }
  });

  $(document).on('click', '[data-search]', function (ev) {
    ev.preventDefault();
    ev.stopPropagation();

    $searchForm.addClass('search--in');
    setTimeout(function() { $searchForm.find('[name="term"]').get(0).focus(); }, 700);
  });

  $searchForm.find('[name="term"]').on('keyup', function (ev) {
    if (ev.which == 13) {
      $searchForm.submit();
    }
  });

  $searchForm.find('[data-search-find]').on('click', function (ev) {
    $body.addClass('loading');
    $searchForm.submit();
  });

  $searchForm.find('.header__search__group').on('click', function (ev) {
    ev.stopPropagation();
  });

  $(document).on('click', function (event) {
    $('.' + targetClass).removeClass(targetClass);
    $button.removeClass(buttonClass);
    $headerBg.removeClass(targetClass);
    $searchForm.removeClass('search--in');
  });

  $searchClose.on('click', function (ev) {
    ev.preventDefault();
    $searchForm.removeClass('search--in');
  });

  if (window.matchMedia('(min-width: 768px)').matches) {
    $(window).on('scrollHandler', function (ev, args) {
      if (($(window).scrollTop() >= 20)) {
        $header.find('.' + targetClass).removeClass(targetClass);
      }
    });
  }

  activeMenu(__cUrlPath || location.pathname);

  function activeMenu(pathname) {
    if (!pathname) {
      return false;
    }
    var $el = $('.header a[href="' + pathname + '"]');
    if ($el.length == 0) {
      var split = pathname.split('/');
      if (split.length > 0) {
        split.pop();
        if (split.length > 0)
          return activeMenu(split.join('/'));
      } else return false;
    } else {
      $el.parents('.header__nav__item, .header__nav-secondary__item').find('a').eq(0).addClass('active');
    }
  }
})();
